/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import Chevron from "../components/Icons/Chevron";
import { GetLectureById } from "../api/Lecture/GetLecturerById";
import { GetCourseById } from "../api/Courses/GetCourseById";
import { getCourses } from "../api/Courses/GetAllCourses";
import { useMutation, useQuery } from "@tanstack/react-query";
import DurationIcon from "../components/Icons/DurationIcon";
import ContentAccordion from "../components/CoursePage/ContentAccordion";
import Spinner from "../components/Shared/Spinner";
import { Disclosure, Transition } from "@headlessui/react";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Accordion } from "../components/Shared/accordion";
import Video2Icon from "../components/Icons/Video2Icon";
import CertificateIcon from "../components/Icons/CertificateIcon";
import VerifyIcon from "../components/Icons/VerifyIcon";
// import VPlayer from "vnetwork-player";
import Button from "../components/Shared/Button";
import EyeFill from "../components/Icons/EyeFill";
import { AddVideoProgress } from "../api/Courses/VideoProgress";
import { queryClient } from "../main";
import { toast } from "react-toastify";
import { GetProgress } from "../api/Courses/GetProgress";
import { ApiError } from "../types/ApiError";
import { GetStudentAnswers } from "../api/Quiz/GetStudentAnswers";
import SadFaceIcon from "../components/Icons/SadFaceIcon";
import { GetEssayAnswers } from "../api/Quiz/GetEssayAnswers";
import { GetExamAnswers } from "../api/Quiz/GetExamAnswers";
import TextArea from "../components/Shared/TextArea";
import { SendFeedback } from "../api/Courses/SendFeedback";
import { ButtonTypes } from "../utils/consts";
import CertificateIcon2 from "../components/Icons/CertificateIcon2";
import {
  CertificateResponse,
  CreateCertificate,
} from "../api/Students/CreateCertificate";
import { useUserDataStore } from "../stores/user";
import { useCertificateStore } from "../stores/certificateStore";
import VdoCipherPlayer from "../components/common/VdoCipherPlayer";

import { Helmet } from "react-helmet";
import { formatDuration } from "../hooks/DurationConverter";
import { SkipQuiz } from "../api/Quiz/SkipQuiz";
import { GetCBQByLecture } from "../api/Quiz/GetCBQByLecture";
import { GetCBQExamSessions } from "../api/Quiz/GetCBQExamSessions";
import { ModalProvider } from "../contexts/ModalContext";
import { formatSubscriptionExpiry } from "../utils/utils";
import { getAccessToken } from "../lib/session";

const Lecture = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const lectureId = id || "";
  const requestedVideoId = useMemo(
    () => new URLSearchParams(location.search).get("video") || "",
    [location.search]
  );
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");
  const [currentVideoId, setCurrentVideoId] = useState("");
  const [currentVideoName, setCurrentVideoName] = useState("");
  const [lastVideoName, setLastVideoName] = useState("");
  const [currentQuizId, setCurrentQuizId] = useState("");
  const [currentQuizName, setCurrentQuizName] = useState("");
  const [currentEssayId, setCurrentEssayId] = useState("");
  const [currentEssayName, setCurrentEssayName] = useState("");
  const [currentExamId, setCurrentExamId] = useState("");
  const [currentExamMCQId, setCurrentExamMCQId] = useState("");
  const [currentExamName, setCurrentExamName] = useState("");
  const [currentCbqId, setCurrentCbqId] = useState("");
  const [currentCbqName, setCurrentCbqName] = useState("");
  const [currentVideoOTP, setCurrentVideoOTP] = useState("");
  const [currentVideoPlayback, setCurrentVideoPlayback] = useState("");
  const [currentIfrsId, setCurrentIfrsId] = useState("");
  const [currentIfrsName, setCurrentIfrsName] = useState("");

  const [feedbackMessage, setFeedbackMessage] = useState("");
  const { userData } = useUserDataStore();
  const { setCertificateData } = useCertificateStore();
  useEffect(() => {
    if (currentVideoId !== "") {
      setCurrentQuizId("");
      setCurrentEssayId("");
      setCurrentExamId("");
      setCurrentExamMCQId("");
      setCurrentIfrsId("");
      setCurrentIfrsName("");
    }
  }, [currentVideoId]);

  // Prevents duplicate PATCH /video/progress calls (manual button + 80% auto).
  const watchedRequestedRef = useRef<Set<string>>(new Set());
  // Optimistic UI so the Watched button disables as soon as we mark progress.
  const [localWatchedIds, setLocalWatchedIds] = useState<Record<string, true>>(
    {}
  );

  const { mutate } = useMutation({
    mutationFn: ({ videoId }: { videoId: string; silent?: boolean }) =>
      AddVideoProgress(videoId),
    onSuccess: (_data, { silent }) => {
      queryClient.invalidateQueries({ queryKey: ["lecture"] });
      queryClient.invalidateQueries({ queryKey: ["progress"] });
      if (!silent) {
        toast("🔥 Video watched successfully");
      }
    },
    onError: (error: unknown, { videoId }) => {
      watchedRequestedRef.current.delete(videoId);
      setLocalWatchedIds((prev) => {
        const next = { ...prev };
        delete next[videoId];
        return next;
      });
      const apiError = error as ApiError;
      if (apiError.statusCode === 400) {
        toast.error(apiError.message);
      } else {
        toast.error("Error Watching Video");
      }
    },
  });

  const { mutate: mutateFeedback } = useMutation({
    mutationFn: SendFeedback,
    onSuccess: () => {
      toast("Feedback sent successfully");
      queryClient.invalidateQueries({ queryKey: ["feedback"] });
      setFeedbackMessage("");
    },
    onError: () => {
      toast.error("Error sending feedback");
    },
  });

  const { mutate: mutateCertificate } = useMutation({
    mutationFn: CreateCertificate,
    onSuccess: (response: CertificateResponse) => {
      //@ts-expect-error
      setCertificateData(response.data);
      navigate("/certificate");
      toast("Certificate request sent successfully");
    },
    onError: () => {
      toast.error("Error requesting certificate");
    },
  });

  const {
    data: LectureByIdDTO,
    isLoading: isLectureLoading,
    // The payload carries VdoCipher otp/playbackInfo pairs that expire a few
    // minutes after the server mints them, so the player needs to know how old
    // this copy is and how to ask for a newer one. See VdoCipherPlayer.
    dataUpdatedAt: lectureFetchedAt,
    refetch: refetchLecture,
  } = useQuery({
    queryFn: () => GetLectureById(lectureId),
    queryKey: ["lecture", lectureId],
    staleTime: 0,
    refetchInterval: 0,
    refetchOnWindowFocus: false,
  });

  const Lecture = LectureByIdDTO?.data;

  const markVideoWatched = useCallback(
    (videoId: string, silent = false) => {
      if (!videoId || watchedRequestedRef.current.has(videoId)) return;
      const video = (Lecture?.videos ?? []).find((v) => v.id === videoId);
      if (video?.watched) return;
      watchedRequestedRef.current.add(videoId);
      setLocalWatchedIds((prev) => ({ ...prev, [videoId]: true }));
      mutate({ videoId, silent });
    },
    [Lecture?.videos, mutate]
  );

  const isCurrentVideoWatched =
    !!currentVideoId &&
    (!!(Lecture?.videos ?? []).find((v) => v.id === currentVideoId)?.watched ||
      !!localWatchedIds[currentVideoId]);

  // The per-lecture CBQ endpoint returns the full session payload (session +
  // scenarios), not a list. staleTime + no window-focus refetch stop it from
  // hammering the endpoint (it can start/touch a session as a side effect).
  const { data: CBQLectureDTO } = useQuery({
    queryFn: () => GetCBQByLecture(lectureId),
    queryKey: ["cbq-lecture", lectureId],
    enabled: !!lectureId,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
  // Only published exams are takeable. For now, only standalone CBQ exams are
  // shown (PROD_WITH_MCQ ones aren't supported in the lecture yet).
  const lectureCbqExams = (CBQLectureDTO?.data ?? [])
    .filter((e) => !!e.publishedAt && e.mode === "STANDALONE_TRAINING")
    // Oldest published first (all have publishedAt from the filter above).
    .sort(
      (a, b) =>
        new Date(a.publishedAt!).getTime() - new Date(b.publishedAt!).getTime()
    );

  const handleCbqSelect = (id: string, name: string) => {
    setCurrentCbqId(id);
    setCurrentCbqName(name);
    setCurrentVideoUrl("");
    setCurrentVideoId("");
    setCurrentQuizId("");
    setCurrentQuizName("");
    setCurrentEssayId("");
    setCurrentEssayName("");
    setCurrentExamName("");
    setCurrentExamId("");
    setCurrentExamMCQId("");
    setCurrentVideoPlayback("");
    setCurrentVideoOTP("");
    setCurrentVideoName("");
    setCurrentIfrsId("");
    setCurrentIfrsName("");
  };

  // Open the confirm-details page; the session is created there on Confirm.
  const handleCbqStart = () => {
    if (!currentCbqId) return;
    navigate(
      `/cbq-exam/start/${currentCbqId}?title=${encodeURIComponent(
        currentCbqName
      )}`,
      {
        state: { from: window.location.pathname },
      }
    );
  };
  const CourseId = Lecture?.course?.id || "";
  const isLoggedIn = !!getAccessToken();

  // The /course/:slug API carries ownership + per-lecture isDemo for the whole
  // course, which the lecture API's sidebar list does not. The lecture API only
  // exposes the course UUID, but /course/:slug needs the slug, so resolve it
  // from the course list first.
  const { data: AllCoursesDTO } = useQuery({
    queryFn: getCourses,
    queryKey: ["courses"],
    staleTime: 0,
  });
  const courseSlug =
    AllCoursesDTO?.data?.coursesData?.find((c) => c.id === CourseId)?.slug || "";
  const { data: CourseByIdDTO } = useQuery({
    queryFn: () => GetCourseById(courseSlug),
    queryKey: ["course", courseSlug],
    staleTime: 0,
    enabled: !!courseSlug,
  });
  const course = CourseByIdDTO?.data;

  // Owner: prefer the course flag; fall back to lecture subscription window.
  const enrolled =
    !!course?.enrolled ||
    !!(Lecture?.subscriptionStartsAt || Lecture?.subscriptionEndsAt);
  const courseAllowsDemo = !!course?.allowDemo;
  // Demo content only unlocks for logged-in, non-owner users.
  const demoEnabled = isLoggedIn && !enrolled && courseAllowsDemo;
  const canOpenItem = (item?: { isDemo?: boolean }) =>
    enrolled || (demoEnabled && !!item?.isDemo);

  // lectureId -> isDemo, sourced from the course API (sidebar list lacks it).
  const lectureDemoMap: Record<string, boolean> = {};
  course?.chapters?.forEach((ch) =>
    ch.lectures?.forEach((lec) => {
      lectureDemoMap[lec.id] = !!lec.isDemo;
    })
  );
  const isLectureAccessible = (lid: string) =>
    enrolled || (demoEnabled && !!lectureDemoMap[lid]);


  const { data: ProgressDTO, isLoading: isProgressLoading } = useQuery({
    queryFn: () => GetProgress(Lecture?.course?.id || ""),
    queryKey: ["progress", CourseId],
    staleTime: 0,
    refetchInterval: 0,
    refetchOnWindowFocus: false,
  });

  const { data: StudentAnswers, isLoading: isAnswersLoading } = useQuery({
    queryFn: () => GetStudentAnswers(currentQuizId),
    queryKey: ["answers", currentQuizId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!currentQuizId,
    refetchOnWindowFocus: false,
  });
  const { data: EssayAnswers, isLoading: isEssayAnswersLoading } = useQuery({
    queryFn: () => GetEssayAnswers(currentEssayId),
    queryKey: ["answers", currentEssayId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!currentEssayId,
    refetchOnWindowFocus: false,
  });
  const { data: ExamAnswers, isLoading: isExamAnswersLoading } = useQuery({
    queryFn: () => GetExamAnswers(currentExamId),
    queryKey: ["answers", currentExamId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!currentExamId,
    refetchOnWindowFocus: false,
  });

  const studentAnswers = StudentAnswers?.data;
  const essayAnswers = EssayAnswers?.data;
  const examAnswers = ExamAnswers?.data;

  // Past CBQ attempts for the selected exam (side-panel "Previous Attempts").
  const { data: CBQSessionsDTO, isLoading: isCbqSessionsLoading } = useQuery({
    queryFn: () => GetCBQExamSessions(currentCbqId),
    queryKey: ["cbq-sessions", currentCbqId],
    enabled: !!currentCbqId,
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
  const cbqSessions = CBQSessionsDTO?.data ?? [];
  const Progress = ProgressDTO?.data?.progressData;
  const accessibleVideos = useMemo(
    () => (Lecture?.videos ?? []).filter((video) => canOpenItem(video)),
    // canOpenItem is derived from enrolled/demoEnabled
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [Lecture?.videos, enrolled, demoEnabled]
  );

  const orderedLectures = useMemo(() => {
    if (!course?.chapters) return [];
    return [...course.chapters]
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      .flatMap((ch) =>
        [...(ch.lectures ?? [])].sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      )
      .filter((lec) => isLectureAccessible(lec.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [course?.chapters, enrolled, demoEnabled]);

  const currentVideoIndex = accessibleVideos.findIndex(
    (video) => video.id === currentVideoId
  );
  const lectureIndex = orderedLectures.findIndex((lec) => lec.id === lectureId);
  const canGoPrevVideo = currentVideoIndex > 0;
  const canGoNextVideo =
    currentVideoIndex >= 0 && currentVideoIndex < accessibleVideos.length - 1;
  const canGoPrevLecture = lectureIndex > 0;
  const canGoNextLecture =
    lectureIndex >= 0 && lectureIndex < orderedLectures.length - 1;
  const prevNavLabel = canGoPrevVideo
    ? "Prev Video"
    : canGoPrevLecture
      ? "Prev Lecture"
      : "Prev Video";
  const nextNavLabel = canGoNextVideo
    ? "Next Video"
    : canGoNextLecture
      ? "Next Lecture"
      : "Next Video";
  const canGoPrev = canGoPrevVideo || canGoPrevLecture;
  const canGoNext = canGoNextVideo || canGoNextLecture;

  // Which lecture the opening video has been chosen for. The payload is
  // refetched on its own now (marking a video watched invalidates it, and the
  // player re-mints its expiring cipher through it), and every refetch used to
  // re-run this and drag the student back to the resume point they had already
  // clicked away from.
  // `openAt` (via location.state) lets Prev/Next Lecture pick first or last video.
  const openedLectureRef = useRef("");
  useEffect(() => {
    const openingKey = `${lectureId}:${requestedVideoId}`;
    if (Lecture?.videos?.length && openedLectureRef.current !== openingKey) {
      const videos = (Lecture?.videos ?? []).filter((video) =>
        canOpenItem(video)
      );
      if (!videos.length) return;

      const openAt = (
        location.state as { openAt?: "first" | "last" } | null
      )?.openAt;
      const target =
        openAt === "first"
          ? videos[0]
          : openAt === "last"
            ? videos[videos.length - 1]
            : videos.find((video) => video.id === requestedVideoId) ||
              videos.find((video) => video.last === true) ||
              videos[0];

      if (target) {
        openedLectureRef.current = openingKey;
        setCurrentVideoUrl(target.url);
        setCurrentVideoId(target.id);
        setCurrentVideoOTP(target.cipher.otp);
        setCurrentVideoName(target.name);
        setLastVideoName(target.name);
        setCurrentVideoPlayback(target.cipher.playbackInfo);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Lecture, lectureId, location.state, requestedVideoId]);

  // Re-mint the expiring VdoCipher pairs. Stable identity: the player holds it
  // across renders and only calls it when its own pair has aged out.
  const refreshCipher = useCallback(() => {
    refetchLecture();
  }, [refetchLecture]);

  // A refetch mints a new cipher for every video; adopt the one belonging to
  // the video actually on screen. The player decides whether it is safe to use
  // it, so this only keeps the freshest pair available to it.
  useEffect(() => {
    if (!currentVideoId) return;
    const video = (Lecture?.videos ?? []).find((v) => v.id === currentVideoId);
    if (!video?.cipher) return;
    setCurrentVideoOTP(video.cipher.otp);
    setCurrentVideoPlayback(video.cipher.playbackInfo);
  }, [Lecture, currentVideoId]);
  const handleLectureClick = (newLectureId: string) => {
    if (!isLectureAccessible(newLectureId)) return;
    navigate(`/lecture/${Lecture?.course?.id}/${newLectureId}`, {
      replace: true,
    });
  };

  const handleVideoSelect = useCallback(
    (
      url: string,
      id: string,
      otp: string,
      playback: string,
      name: string
    ) => {
      setCurrentVideoUrl(url);
      setCurrentVideoId(id);
      setCurrentVideoPlayback(playback);
      setCurrentVideoOTP(otp);
      setCurrentVideoName(name);
      setCurrentCbqId("");
      setCurrentCbqName("");
      setCurrentQuizId("");
      setCurrentQuizName("");
      setCurrentEssayId("");
      setCurrentEssayName("");
      setCurrentExamName("");
      setCurrentExamId("");
      setCurrentExamMCQId("");
    },
    []
  );

  const goToAdjacentLecture = useCallback(
    (direction: "prev" | "next") => {
      const targetIndex =
        direction === "next" ? lectureIndex + 1 : lectureIndex - 1;
      const target = orderedLectures[targetIndex];
      if (!target || !CourseId) return;
      navigate(`/lecture/${CourseId}/${target.id}`, {
        replace: true,
        state: { openAt: direction === "next" ? "first" : "last" },
      });
    },
    [CourseId, lectureIndex, navigate, orderedLectures]
  );

  const goToPrevVideo = useCallback(() => {
    if (canGoPrevVideo) {
      const prev = accessibleVideos[currentVideoIndex - 1];
      handleVideoSelect(
        prev.url,
        prev.id,
        prev.cipher.otp,
        prev.cipher.playbackInfo,
        prev.name
      );
      return;
    }
    if (canGoPrevLecture) goToAdjacentLecture("prev");
  }, [
    accessibleVideos,
    canGoPrevLecture,
    canGoPrevVideo,
    currentVideoIndex,
    goToAdjacentLecture,
    handleVideoSelect,
  ]);

  const goToNextVideo = useCallback(() => {
    if (canGoNextVideo) {
      const next = accessibleVideos[currentVideoIndex + 1];
      handleVideoSelect(
        next.url,
        next.id,
        next.cipher.otp,
        next.cipher.playbackInfo,
        next.name
      );
      return;
    }
    if (canGoNextLecture) goToAdjacentLecture("next");
  }, [
    accessibleVideos,
    canGoNextLecture,
    canGoNextVideo,
    currentVideoIndex,
    goToAdjacentLecture,
    handleVideoSelect,
  ]);

  const handleQuizSelect = (id: string, name: string) => {
    setCurrentQuizName(name);
    setCurrentCbqId("");
    setCurrentCbqName("");
    setCurrentQuizId(id);
    setCurrentVideoUrl("");
    setCurrentVideoId("");
    setCurrentEssayId("");
    setCurrentEssayName("");
    setCurrentExamName("");
    setCurrentExamId("");
    setCurrentVideoPlayback("");
    setCurrentVideoOTP("");
    setCurrentVideoName("");
    setCurrentExamMCQId("");
  };
  const handleExamSelect = (id: string, name: string, mcqId: string) => {
    setCurrentExamName(name);
    setCurrentCbqId("");
    setCurrentCbqName("");
    setCurrentExamId(id);
    setCurrentExamMCQId(mcqId);
    setCurrentQuizName("");
    setCurrentQuizId("");
    setCurrentVideoUrl("");
    setCurrentVideoId("");
    setCurrentEssayId("");
    setCurrentEssayName("");
    setCurrentVideoPlayback("");
    setCurrentVideoOTP("");
    setCurrentVideoName("");
  };

  const handleEssaySelect = (id: string, name: string) => {
    setCurrentEssayName(name);
    setCurrentCbqId("");
    setCurrentCbqName("");
    setCurrentEssayId(id);
    setCurrentVideoUrl("");
    setCurrentVideoId("");
    setCurrentQuizId("");
    setCurrentQuizName("");
    setCurrentExamName("");
    setCurrentExamId("");
    setCurrentVideoPlayback("");
    setCurrentVideoOTP("");
    setCurrentVideoName("");
    setCurrentExamMCQId("");
  };

  const handleIfrsSelect = (id: string, name: string) => {
    setCurrentIfrsId(id);
    setCurrentIfrsName(name);
    setCurrentCbqId("");
    setCurrentCbqName("");
    setCurrentVideoUrl("");
    setCurrentVideoId("");
    setCurrentQuizId("");
    setCurrentQuizName("");
    setCurrentEssayId("");
    setCurrentEssayName("");
    setCurrentExamName("");
    setCurrentExamId("");
    setCurrentVideoPlayback("");
    setCurrentVideoOTP("");
    setCurrentVideoName("");
    setCurrentExamMCQId("");
  };

  const handleFeedbackSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const payload = {
      videoId: currentVideoId,
      message: feedbackMessage,
    };
    mutateFeedback(payload);
  };

  const handleGetCertified = () => {
    const payload = {
      studentId: userData?.id || "",
      courseId: CourseId,
      instructorId: Lecture?.instructor?.id || "",
    };
    mutateCertificate(payload);
  };

  useEffect(() => {
    const handleContextMenu = (e: Event) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);
  const calculateTotalDuration = (chapters: any[]) => {
    let totalDurationInSeconds = 0;

    chapters?.forEach((chapter) => {
      chapter?.lectures?.forEach((lecture: { duration: number }) => {
        totalDurationInSeconds += lecture?.duration;
      });
    });

    return totalDurationInSeconds;
  };

  if (isLectureLoading)
    return (
      <ModalProvider>
        <div className="flex items-center justify-center min-h-screen">
          <Spinner />
        </div>
      </ModalProvider>
    );
  if (!Lecture) {
    return (
      <ModalProvider>
        <div className="flex items-center justify-center min-h-screen">
          <Spinner />
        </div>
      </ModalProvider>
    );
  }

  const totalModules = Lecture?.chapter?.length || 0;
  const totalLectures =
    Lecture?.chapter?.reduce(
      (acc, chapter) => acc + chapter?.lectures?.length,
      0
    ) || 0;

  const activeLectureItemId = `lecture-${Lecture?.chapter?.findIndex(
    (ch) => ch.id === Lecture?.chapterId
  )}-${Lecture?.chapter
    ?.find((ch) => ch.id === Lecture?.chapterId)
    ?.lectures?.findIndex((lec) => lec.id === lectureId)}`;

  const totalDurationInSeconds = calculateTotalDuration(Lecture?.chapter);
  const formattedDuration = formatDuration(totalDurationInSeconds);
  const skipQuizFn = async (courseId: string) => {
    await SkipQuiz(courseId);
    window.location.reload();
  };

  return (
    <ModalProvider>
      <div className="pt-32 xl:pt-40 lg:pt-48 md:pt-52 pb-36">
        <Helmet>
          <link
            rel="canonical"
            href={`https://www.nilewisect.com/lecture/${Lecture?.title}`}
          />
        </Helmet>

        <div className="container pt-16 mt-0.5">
          {Number(Progress?.percentage) === 100 && (
            <div className="flex flex-col items-center justify-between w-full gap-6 px-4 py-4 mb-8 text-white bg-no-repeat bg-cover rounded-lg bg-primary sm:px-10 sm:py-6 bg-heroBg md:flex-row">
              <div className="gap-2 sm:flex sm:gap-5">
                <CertificateIcon2 className="text-secondary sm:min-w-[60px] sm:min-h-[60px] sm:h-[60px] sm:w-[60px] min-w-12 min-h-12 w-12 h-12 mx-auto sm:mx-0" />
                <div>
                  <h1 className="mb-1 text-lg font-bold text-center sm:text-2xl leading-0 sm:text-start">
                    You're ready to get{" "}
                    <span className="text-secondary">Certified!</span>
                  </h1>
                  <p className="sm:text-base text-sm font-medium max-w-[811px]  text-white/80  sm:text-start text-center">
                    Elevate your career and prove your skills with AAA
                    Certification: Recognized industry-wide, begin now.
                  </p>
                </div>
              </div>
              <Button
                variant="secondary"
                className="md:min-w-[162px] md:w-auto w-full text-xs font-semibold sm:h-9 h-8 rounded-lg"
                onClick={handleGetCertified}
              >
                {" "}
                Get Certification
              </Button>
            </div>
          )}
          <div className="flex flex-col justify-between gap-6 lg:flex-row">
            <div className="lg:max-w-[800px] w-full">
              <div className="flex sm:gap-2 gap-0.5 items-start sm:mb-6 mb-3">
                <div className="sm:w-2 w-1.5 sm:min-h-[64px] min-h-[42px] rounded-2xl bg-primary mr-1"></div>
                <div className="flex items-center my-auto sm:gap-2 gap-0.5 flex-wrap">
                  <Link
                    to={`/course/${Lecture?.course?.id}`}
                    className="flex items-center gap-0.5 text-burntBlack/85 font-medium sm:text-lg text-sm -tracking-[0.02em] cursor-pointer "
                  >
                    Course <Chevron className="sm:size-auto size-4" />
                  </Link>
                  <div className="flex items-center gap-0.5 text-burntBlack font-semibold sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
                    {Lecture?.course?.name}{" "}
                    <Chevron className="sm:size-auto size-4" />
                  </div>
                  <div className="flex items-center gap-0.5 text-burntBlack font-semibold sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
                    {Lecture?.title} <Chevron className="sm:size-auto size-4" />
                  </div>
                  <div className="flex items-center gap-0.5 text-burntBlack font-semibold sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
                    {Lecture?.videos && <>{currentVideoName || lastVideoName}</>}
                  </div>
                </div>
              </div>
              <div className="sm:mb-10 mb-11 pb-0.5 rounded-xl overflow-hidden">
                {Lecture?.videos ? (
                  <>
                    {currentEssayId && (
                      <>
                        {essayAnswers?.quizDetails ? (
                          <>
                            {isEssayAnswersLoading ? (
                              <div className="h-[450px] flex items-center justify-center">
                                <Spinner />
                              </div>
                            ) : (
                              <div className="quiz-container text-center max-h-[450px]">
                                <h1 className="font-bold text-burntBlack sm:text-28px">
                                  {currentEssayName}
                                </h1>
                                <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                                  Previous Attempts:
                                </h1>
                                <div className="max-h-[250px] overflow-y-scroll">
                                  {[...(essayAnswers?.quizDetails ?? [])]
                                    .sort((a, b) => a.num_tries - b.num_tries)
                                    .map((answer) => (
                                    <button
                                      key={answer.num_tries}
                                      onClick={() => window.open(`/essay-quiz-answers/${currentEssayId}/${answer.num_tries}`, '_blank')}
                                      className="w-full cursor-pointer hover:bg-gray-50 rounded-lg px-3 py-2 transition-colors border border-transparent hover:border-gray-200"
                                    >
                                      <h1 className="font-semibold text-primary underline">
                                        Attempt #{answer.num_tries}
                                      </h1>
                                      <div className="flex justify-center gap-10 px-5 my-1">
                                        <h1 className="font-semibold">
                                          Score: {answer.score}%
                                        </h1>
                                        <h1
                                          className={`font-semibold ${answer.status === "failed"
                                            ? "text-red-500"
                                            : answer.status === "skipped"
                                              ? "text-yellow-500"
                                              : "text-green-500"
                                            } `}
                                        >
                                          {answer.status}
                                        </h1>
                                      </div>
                                    </button>
                                  ))}
                                </div>
                                <Link to={`/essay-quiz/${currentEssayId}`}>
                                  <Button
                                    variant="primary"
                                    className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                                  >
                                    Take the quiz again
                                  </Button>
                                  {essayAnswers?.quizDetails.some(
                                    (answer) => answer.status === "failed"
                                  ) && (
                                      <Button
                                        variant="transparent"
                                        className="w-full max-w-[70%] mx-auto mt-2 md:!h-16 !h-12 md:!text-xl !text-sm"
                                        onClick={() =>
                                          skipQuizFn(Lecture?.course?.id)
                                        }
                                      >
                                        Skip All Quizzes
                                      </Button>
                                    )}
                                </Link>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="quiz-container text-center h-[450px] flex flex-col justify-center gap-4">
                            <h1 className="font-bold text-burntBlack sm:text-28px">
                              {currentEssayName}
                            </h1>
                            <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                              You have not attempted this quiz yet
                            </h1>
                            <Link to={`/essay-quiz/${currentEssayId}`}>
                              <Button
                                variant="primary"
                                className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                              >
                                Start Quiz
                              </Button>
                              <Button
                                variant="transparent"
                                className="w-full max-w-[70%] mx-auto mt-2 md:!h-16 !h-12 md:!text-xl !text-sm"
                                onClick={() => skipQuizFn(Lecture?.course?.id)}
                              >
                                Skip All Quizzes
                              </Button>
                            </Link>
                          </div>
                        )}
                      </>
                    )}
                    {currentExamId && (
                      <>
                        {examAnswers ? (
                          <>
                            {isExamAnswersLoading ? (
                              <div className="h-[450px] flex items-center justify-center">
                                <Spinner />
                              </div>
                            ) : (
                              <div className="quiz-container text-center max-h-[450px]">
                                <h1 className="font-bold text-burntBlack sm:text-28px">
                                  {currentExamName}
                                </h1>
                                <div className="max-h-[250px] overflow-y-scroll">
                                  <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                                    Previous MCQ Attempts:
                                  </h1>
                                  <div>
                                    {[...(examAnswers?.mcqResponse?.studentAnswers ?? [])]
                                      .sort((a, b) => a.num_tries - b.num_tries)
                                      .map(
                                      (answer) => (
                                        <Link
                                          to={`/quiz-answers/${currentExamMCQId}/${answer.num_tries}`}
                                          key={answer.num_tries}
                                        >
                                          <h1 className="font-semibold">
                                            Number of Attempt: {answer.num_tries}
                                          </h1>
                                          <div className="flex justify-center gap-10 px-5 my-4">
                                            <h1 className="font-semibold">
                                              Score: {answer.score}%
                                            </h1>
                                            <h1
                                              className={`font-semibold ${answer.status === "failed"
                                                ? "text-red-500"
                                                : "text-green-500"
                                                } `}
                                            >
                                              Status: {answer.status}
                                            </h1>
                                          </div>
                                        </Link>
                                      )
                                    )}
                                  </div>
                                  <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                                    Previous Essay Attempts:
                                  </h1>
                                  <div>
                                    {[...(examAnswers?.essayResponse?.quizDetails ?? [])]
                                      .sort((a, b) => a.num_tries - b.num_tries)
                                      .map(
                                      (answer) => (
                                        <div key={answer.num_tries}>
                                          <h1 className="font-semibold">
                                            Number of Attempt: {answer.num_tries}
                                          </h1>
                                          <div className="gap-10 px-5 my-4">
                                            <h1 className="font-semibold">
                                              Score: {answer.score}%
                                            </h1>
                                            <h1
                                              className={`font-semibold ${answer.status === "failed"
                                                ? "text-red-500"
                                                : "text-green-500"
                                                } `}
                                            >
                                              Status: {answer.status}
                                            </h1>
                                            {answer.question.map((question) => (
                                              <div key={answer.num_tries}>
                                                <h1 className="text-xs font-semibold text-primary">
                                                  Q. {question.question}
                                                </h1>
                                                <h1 className="text-xs">
                                                  A. {question.explanation}
                                                </h1>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )
                                    )}
                                  </div>
                                </div>
                                <Link to={`/exam/${currentExamId}`}>
                                  <Button
                                    variant="primary"
                                    className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                                  >
                                    Take the exam again
                                  </Button>
                                </Link>
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="quiz-container text-center h-[450px] flex flex-col justify-center gap-4">
                            <h1 className="font-bold text-burntBlack sm:text-28px">
                              {currentExamName}
                            </h1>
                            <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                              You have not attempted this Exam yet
                            </h1>
                            <Link to={`/exam/${currentExamId}`}>
                              <Button
                                variant="primary"
                                className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                              >
                                Start Exam
                              </Button>
                            </Link>
                          </div>
                        )}
                      </>
                    )}
                    {currentQuizId && (
                      <>
                        {studentAnswers ? (
                          <>
                            {isAnswersLoading ? (
                              <div className="h-[450px] flex items-center justify-center">
                                <Spinner />
                              </div>
                            ) : (
                              <div className="quiz-container text-center max-h-[450px]">
                                <h1 className="font-bold text-burntBlack sm:text-28px">
                                  {currentQuizName}
                                </h1>
                                <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                                  Previous Attempts:
                                </h1>
                                <div className="max-h-[250px] overflow-y-scroll">
                                  {[...(studentAnswers?.studentAnswers ?? [])]
                                    .sort((a, b) => a.num_tries - b.num_tries)
                                    .map(
                                    (answer) => (
                                      <button
                                        key={answer.num_tries}
                                        onClick={() => window.open(`/quiz-answers/${currentQuizId}/${answer.num_tries}`, '_blank')}
                                        className="w-full cursor-pointer hover:bg-gray-50 rounded-lg px-3 py-2 transition-colors border border-transparent hover:border-gray-200"
                                      >
                                        <h1 className="font-semibold text-primary underline">
                                          Attempt #{answer.num_tries}
                                        </h1>
                                        <div className="flex justify-center gap-10 px-5 my-1">
                                          <h1 className="font-semibold">
                                            Score: {answer.score}%
                                          </h1>
                                          <h1
                                            className={`font-semibold ${answer.status === "failed"
                                              ? "text-red-500"
                                              : answer.status === "skipped"
                                                ? "text-yellow-500"
                                                : "text-green-500"
                                              } `}
                                          >
                                            {answer.status}
                                          </h1>
                                        </div>
                                      </button>
                                    )
                                  )}
                                </div>
                                <Link to={`/quiz/${currentQuizId}`}>
                                  <Button
                                    variant="primary"
                                    className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                                  >
                                    Take the quiz again
                                  </Button>
                                </Link>

                                {studentAnswers?.studentAnswers.some(
                                  (answer) => answer.status === "failed"
                                ) && (
                                    <Button
                                      variant="transparent"
                                      className="w-full max-w-[70%] mx-auto mt-2 md:!h-16 !h-12 md:!text-xl !text-sm"
                                      onClick={() =>
                                        skipQuizFn(Lecture?.course?.id)
                                      }
                                    >
                                      Skip All Quizzes
                                    </Button>
                                  )}
                              </div>
                            )}
                          </>
                        ) : (
                          <div className="quiz-container text-center h-[450px] flex flex-col justify-center gap-4">
                            <h1 className="font-bold text-burntBlack sm:text-28px">
                              {currentQuizName}
                            </h1>
                            <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                              You have not attempted this quiz yet
                            </h1>
                            <Link to={`/quiz/${currentQuizId}`}>
                              <Button
                                variant="primary"
                                className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                              >
                                Start Quiz
                              </Button>
                            </Link>
                            <Button
                              variant="transparent"
                              className="w-full max-w-[70%] mx-auto mt-2 md:!h-16 !h-12 md:!text-xl !text-sm"
                              onClick={() => skipQuizFn(Lecture?.course?.id)}
                            >
                              Skip All Quizzes
                            </Button>
                          </div>
                        )}
                      </>
                    )}
                    {currentVideoUrl && (
                      <>
                        <div className="border video-container border-primary">
                          {/* <VPlayer
                          source={`https://player.vdocipher.com/v2/?otp=${currentVideoOTP}&playbackInfo=${currentVideoPlayback}`}
                          color="#2058AD"
                        /> */}
                          <VdoCipherPlayer
                            videoId={currentVideoId}
                            otp={currentVideoOTP}
                            playbackInfo={currentVideoPlayback}
                            cipherFetchedAt={lectureFetchedAt}
                            onRefresh={refreshCipher}
                            onWatchThreshold={() =>
                              markVideoWatched(currentVideoId, true)
                            }
                            onEnded={goToNextVideo}
                            className="w-full sm:h-[450px] h-[300px] object-cover border-0"
                          />
                        </div>
                        <div className="flex items-center justify-between gap-3 mt-3">
                          <Button
                            onClick={goToPrevVideo}
                            variant="gray"
                            disabled={!canGoPrev}
                            className="!h-10 !text-sm sm:!text-base !px-3 sm:!px-4 disabled:opacity-50"
                          >
                            <Chevron className="rotate-180 size-4" />
                            {prevNavLabel}
                          </Button>
                          <Button
                            onClick={goToNextVideo}
                            variant="gray"
                            disabled={!canGoNext}
                            className="!h-10 !text-sm sm:!text-base !px-3 sm:!px-4 disabled:opacity-50"
                          >
                            {nextNavLabel}
                            <Chevron className="size-4" />
                          </Button>
                        </div>
                      </>
                    )}
                    {currentIfrsId && (
                      <div className="quiz-container text-center h-[450px] flex flex-col justify-center gap-4">
                        <h1 className="font-bold text-burntBlack sm:text-28px">
                          {currentIfrsName}
                        </h1>
                        <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                          You have not attempted this exam yet
                        </h1>
                        <Link to={`/ifrs-exam/${currentIfrsId}`} state={{ from: window.location.pathname }}>
                          <Button
                            variant="primary"
                            className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                          >
                            Start Exam
                          </Button>
                        </Link>
                      </div>
                    )}
                    {currentCbqId && (
                      <>
                        {isCbqSessionsLoading ? (
                          <div className="h-[450px] flex items-center justify-center">
                            <Spinner />
                          </div>
                        ) : cbqSessions.length > 0 ? (
                          <div className="quiz-container text-center max-h-[450px]">
                            <h1 className="font-bold text-burntBlack sm:text-28px">
                              {currentCbqName}
                            </h1>
                            <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                              Previous Attempts:
                            </h1>
                            <div className="max-h-[250px] overflow-y-scroll">
                              {cbqSessions.map((session, i) => {
                                const isSubmitted =
                                  session.status === "submitted";
                                const isInProgress =
                                  session.status === "in_progress";
                                const clickable = isSubmitted || isInProgress;
                                const openAttempt = () =>
                                  navigate(
                                    isSubmitted
                                      ? `/cbq-exam/${session.id}/result`
                                      : `/cbq-exam/${session.id}`,
                                    {
                                      state: {
                                        from: window.location.pathname,
                                      },
                                    }
                                  );
                                return (
                                <div
                                  key={session.id}
                                  onClick={clickable ? openAttempt : undefined}
                                  role={clickable ? "button" : undefined}
                                  className={`px-3 py-2 border-b border-black/10 transition-colors ${
                                    clickable
                                      ? "cursor-pointer hover:bg-black/5"
                                      : ""
                                  }`}
                                >
                                  <h1 className="font-semibold text-primary">
                                    Attempt #{session.attemptNumber ?? i + 1}
                                  </h1>
                                  <div className="flex justify-center gap-10 px-5 my-1">
                                    <h1 className="font-semibold">
                                      Score:{" "}
                                      {session.totalScore != null
                                        ? session.totalScore
                                        : "—"}
                                    </h1>
                                    <h1
                                      className={`font-semibold ${
                                        session.status === "submitted"
                                          ? "text-green-500"
                                          : "text-yellow-500"
                                      }`}
                                    >
                                      {session.status === "in_progress"
                                        ? "in progress"
                                        : session.status}
                                    </h1>
                                  </div>
                                  <p className="text-xs text-lightGray">
                                    {session.submittedAt
                                      ? new Date(
                                          session.submittedAt
                                        ).toLocaleString()
                                      : session.createdAt
                                      ? `Started ${new Date(
                                          session.createdAt
                                        ).toLocaleString()}`
                                      : ""}
                                  </p>
                                  {clickable && (
                                    <p className="mt-1 text-sm font-semibold text-primary underline">
                                      {isSubmitted ? "Show result" : "Resume exam"}
                                    </p>
                                  )}
                                </div>
                                );
                              })}
                            </div>
                            <Button
                              variant="primary"
                              onClick={handleCbqStart}
                              className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                            >
                              {cbqSessions.some((s) => s.status === "in_progress")
                                ? "Resume Exam"
                                : "Start Exam Again"}
                            </Button>
                          </div>
                        ) : (
                          <div className="quiz-container text-center h-[450px] flex flex-col justify-center gap-4">
                            <h1 className="font-bold text-burntBlack sm:text-28px">
                              {currentCbqName}
                            </h1>
                            <h1 className="mb-4 text-xl font-semibold sm:text-2xl">
                              You have not attempted this exam yet
                            </h1>
                            <Button
                              variant="primary"
                              onClick={handleCbqStart}
                              className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                            >
                              Start Exam
                            </Button>
                          </div>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <div className="h-[450px] max-w-[700px] mx-auto flex flex-col justify-center items-center gap-5 text-primary font-semibold text-2xl">
                    <SadFaceIcon />
                    <h1 className="text-center">
                      Sorry for not showing the content, But you can't watch this
                      lecture content unless you pass all the previous quizzes.{" "}
                    </h1>
                    <p className="text-sm text-gray-300">
                      (We care about your understanding of the course content.)
                    </p>
                  </div>
                )}
              </div>
              <div>
                <div className="sm:mt-5 sm:pt-0.5">
                  <div className="flex items-center justify-between mb-4 sm:mb-6">
                    <div>
                      <h1 className="font-bold text-burntBlack sm:text-28px">
                        {Lecture?.title}
                      </h1>
                      {Lecture?.videos && (
                        <h2 className="text-sm font-bold text-burntBlack sm:text-xl">
                          {currentVideoName || lastVideoName}
                        </h2>
                      )}
                    </div>
                    <Button
                      onClick={() => markVideoWatched(currentVideoId)}
                      variant="primary"
                      disabled={!currentVideoId || isCurrentVideoWatched}
                      className={`!h-10 !text-base w-[150px] ${
                        isCurrentVideoWatched
                          ? "!bg-green-600 hover:!bg-green-600 !cursor-not-allowed opacity-90"
                          : ""
                      }`}
                    >
                      {isCurrentVideoWatched ? (
                        <>
                          Watched <VerifyIcon className="ml-2 size-5" />
                        </>
                      ) : (
                        <>
                          Watched <EyeFill className="ml-4" />
                        </>
                      )}
                    </Button>
                  </div>
                  <div className="hidden md:block">
                    <h1 className="mb-4 font-bold sm:mb-6 text-burntBlack sm:text-xl">
                      This course includes :
                    </h1>
                    <div className="flex-wrap items-center justify-start gap-5 space-y-4 md:flex md:divide-x-2 md:space-y-0 lg:w-full">
                      <div className="flex items-center gap-2.5">
                        <Video2Icon className="size-6" />{" "}
                        <span className="text-lightGray">
                          Hours on-demand video
                        </span>
                      </div>
                      <div className="flex items-center gap-2.5  md:pl-4">
                        <VerifyIcon className="size-6" />{" "}
                        <span className="text-lightGray">
                          All features access
                        </span>
                      </div>
                      <div className="flex items-center gap-2.5 md:pl-4">
                        <CertificateIcon className="size-6" />{" "}
                        <span className="text-lightGray">
                          Certificate of compilation
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div className="lg:mr-9">
                {!isProgressLoading && (
                  <>
                    <div className="flex justify-between items-center gap-2 mb-2">
                      <p className="text-lightGray tracking-[0.02em] text-xs sm:text-sm font-medium whitespace-nowrap">
                        Your progress -{" "}
                        {isNaN(parseFloat(`${Progress?.percentage}`))
                          ? 0
                          : parseFloat(`${Progress?.percentage}`).toFixed(2)}
                        %
                      </p>
                      {Lecture?.subscriptionEndsAt && Lecture.subscriptionEndsAt > 0 && (
                        <span
                          className="text-xs font-medium text-secondary sm:text-sm min-w-fit whitespace-nowrap"
                          title="Time left until lecture access expires"
                        >
                          {formatSubscriptionExpiry(Lecture.subscriptionEndsAt)}
                        </span>
                      )}
                    </div>
                    <div className="h-2.5 rounded-[30px] bg-[#D9D9D9] overflow-hidden mb-5 sm:mb-6">
                      <div
                        style={{
                          width: `${isNaN(parseFloat(`${Progress?.percentage}`))
                            ? 0
                            : parseFloat(`${Progress?.percentage}`).toFixed(2)
                            }%`,
                        }}
                        className="h-full bg-primary"
                      ></div>
                    </div>
                  </>
                )}

                <h1 className="sm:mb-3 mb-2.5 text-burntBlack tracking-[0.02em] font-bold text-lg sm:text-2xl">
                  Course Content
                </h1>
                <div className="bg-[#F5F5F5] h-12 sm:h-[60px] rounded-lg px-3 flex items-center justify-between">
                  <span className="text-xs font-medium sm:text-base text-lightGray">
                    {totalModules} Modules - {totalLectures} Lesson
                  </span>
                  <div className="font-medium sm:text-base text-xs text-lightGray flex items-center gap-1.5">
                    <DurationIcon className="sm:size-auto size-[14px]" />
                    {formattedDuration} Hours Total
                  </div>
                </div>
              </div>
              <div className="space-y-4 max-h-[620px] overflow-y-scroll overflow-x-hidden pr-5 scrollbar bg-white">
                {Lecture?.chapter
                  ?.sort((a, b) => a.order - b.order)
                  .map((chapter, index) => (
                    <Disclosure
                      key={`chapter-${index}`}
                      defaultOpen={chapter?.id === Lecture?.chapterId}
                    >
                      {({ open }) => (
                        <div>
                          <Disclosure.Button
                            className={`relative border-b py-4 items-center gap-4 flex w-full justify-between text-left font-semibold  text-sm sm:text-lg duration-300 transition-all ease-in-out  ${open
                              ? "text-primary border-transparent"
                              : "text-burntBlack border-[#D0D5DD]"
                              }`}
                          >
                            <span>{chapter?.name}</span>
                            <div className="flex items-center justify-center gap-4">
                              <p className="text-sm">
                                {formatDuration(Number(chapter?.duration)) ||
                                  "00:00"}
                              </p>
                              <Chevron
                                width={24}
                                height={24}
                                className={`!text-inherit sm:size-auto size-[18px] transition duration-300 ease-in-out ${open
                                  ? "rotate-[270deg] text-primary"
                                  : "rotate-90 text-burntBlack"
                                  }`}
                              />
                            </div>
                          </Disclosure.Button>
                          <Transition
                            show={open}
                            enter="transition duration-300 ease-out"
                            enterFrom="transform scale-95 opacity-0"
                            enterTo="transform scale-100 opacity-100"
                            leave="transition duration-150 ease-out"
                            leaveFrom="transform scale-100 opacity-100"
                            leaveTo="transform scale-95 opacity-0"
                          >
                            <Disclosure.Panel className="bg-white">
                              <Accordion
                                type="single"
                                collapsible
                                className="w-full ml-4"
                                defaultValue={activeLectureItemId}
                              >
                                {chapter?.lectures
                                  ?.sort((a, b) => a.order - b.order)
                                  ?.map((lecture, lectureIndex) => (
                                    <ContentAccordion
                                      lectureTime={
                                        formatDuration(
                                          Number(lecture?.duration)
                                        ) || "00:00"
                                      }
                                      onExamSelect={handleExamSelect}
                                      onEssaySelect={handleEssaySelect}
                                      onQuizSelect={handleQuizSelect}
                                      onIfrsSelect={handleIfrsSelect}
                                      data={Lecture}
                                      onVideoSelect={handleVideoSelect}
                                      lectureName={lecture?.title}
                                      itemId={`lecture-${index}-${lectureIndex}`}
                                      onClick={() =>
                                        handleLectureClick(lecture?.id)
                                      }
                                      isActive={lectureId === lecture?.id}
                                      activeQuizUrl={currentQuizId}
                                      activeVideoId={currentVideoId}
                                      activeEssayUrl={currentEssayId}
                                      activeExamUrl={currentExamId}
                                      activeIfrsUrl={currentIfrsId}
                                      cbqExams={lectureCbqExams}
                                      onCbqSelect={handleCbqSelect}
                                      activeCbqUrl={currentCbqId}
                                      canAccess={enrolled}
                                      demoEnabled={demoEnabled}
                                      lectureLocked={
                                        !isLectureAccessible(lecture?.id)
                                      }
                                      key={lectureIndex}
                                    />
                                  ))}
                              </Accordion>
                            </Disclosure.Panel>
                          </Transition>
                        </div>
                      )}
                    </Disclosure>
                  ))}
              </div>
            </div>
          </div>

          <div className="block mt-10 md:hidden">
            <h1 className="mb-4 font-bold md:mb-6 text-burntBlack md:text-2xl">
              This course includes :
            </h1>
            <div className=" md:flex md:divide-x-2 justify-between items-center md:space-y-0 space-y-4 lg:w-[125%]">
              <div className="flex items-center gap-2.5">
                <Video2Icon className="size-6" />{" "}
                <span className="text-lightGray">Hours on-demand video</span>
              </div>
              <div className="flex items-center gap-2.5  md:pl-4">
                <VerifyIcon className="size-6" />{" "}
                <span className="text-lightGray">All features access</span>
              </div>
              <div className="flex items-center gap-2.5 md:pl-4">
                <CertificateIcon className="size-6" />{" "}
                <span className="text-lightGray">Certificate of compilation</span>
              </div>
            </div>
          </div>
          <form className="mt-5" onSubmit={handleFeedbackSubmit}>
            <h1 className="mb-4 font-bold md:mb-6 text-burntBlack md:text-2xl">
              Write your feedback about this lecture?.
            </h1>
            <TextArea
              placeholder="Feedback"
              name="message"
              value={feedbackMessage}
              onChange={(e) => setFeedbackMessage(e.target.value)}
            />
            <Button
              type={ButtonTypes.SUBMIT}
              variant="primary"
              className="!h-10 !text-base w-[150px] mt-3"
            >
              Send Feedback
            </Button>
          </form>
          <div className="pt-10 mt-10 border-t md:pt-12 md:mt-16">
            <div className="flex flex-wrap items-center justify-between gap-10">
              <div className="flex items-center sm:gap-4 gap-2.5">
                <div className="sm:size-[100px] size-12 rounded-full overflow-hidden border border-black/20">
                  <img
                    className="object-cover object-[25%_75%] "
                    src={Lecture?.instructor?.photo}
                    alt="Instructor"
                  />
                </div>
                <div className="text-burntBlack">
                  <h1 className="mb-0.5 sm:text-2xl font-bold">
                    Dr. {Lecture?.instructor?.firstName}{" "}
                    {Lecture?.instructor?.lastName}
                  </h1>
                  <p className="text-lightGray font-medium sm:text-xl tracking-[0.02em]">
                    Instructor
                  </p>
                </div>
              </div>
              <Link
                className="bg-[#F5F5F5] rounded-lg px-6 py-2.5 text-lightGray hover:bg-burntBlack hover:text-white duration-300 transition-all ease-in-out font-semibold text-lg sm:w-auto w-full text-center"
                to={`/instructor/${Lecture?.instructor?.id}`}
              >
                View Profile
              </Link>
            </div>
          </div>
        </div>

      </div>
    </ModalProvider>
  );
};
export default Lecture;
